angular.module('dentalLinks')
.controller('NavController', ['$scope', '$state', '$window', '$uibModal', 'Auth', 'Logger', 'Login', 'Spinner', 'UnsavedChanges', 'User', 'HTTP_ERROR_EVENTS', 'Notification', 'ProgressIndicator', 'Impersonation', 'ImpersonationState', '$location', 'AccountSetupActions', 'PatientPortal', 'redirect', 'EmailSuppressionWarning', 'TrialExpiryWarning', 'AUTH_EVENTS', 'CustomBranding',
    function ($scope, $state, $window, $uibModal, Auth, Logger, Login, Spinner, UnsavedChanges, User, HTTP_ERROR_EVENTS, Notification, ProgressIndicator, Impersonation, ImpersonationState, $location, AccountSetupActions, PatientPortal, redirect, EmailSuppressionWarning, TrialExpiryWarning, AUTH_EVENTS, CustomBranding) {

        $scope.progress = ProgressIndicator.get();
        $scope.loading = Spinner.loading();

        // Expose Auth.current_user on the scope as a live getter so templates
        // (e.g. the Patient Portal Premium badge) always see the latest value
        // without having to re-assign on every Auth.current_user reassignment.
        Object.defineProperty($scope, 'current_user', {
            get: function() { return Auth.current_user; }
        });

        // List of public paths that don't require user data loading.
        // '/error' is not one of them: a signed-in user is sent there from
        // pages like /confirm_email and keeps the logged-in header, which needs
        // their name. A stale cookie there is cleared by the authInterceptor.
        var publicPaths = [
            '/sign_in',
            '/guest_or_login',
            '/register',
            '/register_confirmation',
            '/edit_password',
            '/add_password',
            '/reset_password',
            '/unsubscribe',
            '/confirm_email',
            '/create_guest_referral',
            '/license',
            '/activate_guest_referral',
            '/guest_referral_activated',
            '/offer_convert_guest'
        ];

        // Check if a path (the current one by default) is a public page where
        // we shouldn't load user data
        function isPublicPage(path) {
            path = path === undefined ? $location.path() : path;
            for (var i = 0; i < publicPaths.length; i++) {
                if (path.startsWith(publicPaths[i])) {
                    return true;
                }
            }
            return false;
        }

        // Only load user data if authenticated AND not on a public page
        // This prevents unnecessary 401 errors when users have stale auth cookies
        function loadCurrentUser() {
            var auth = Auth.get();
            Auth.current_user = User.get({id: auth.id}, function(user) {
                // User successfully loaded
                // Evaluate post-login account setup actions on initial authenticated load.
                AccountSetupActions.checkAndShow();
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load current user', error);
                }
            });
        }

        function shouldLoadCurrentUser(path) {
            var auth = Auth.get();
            return !!(auth && auth.id && !Auth.current_user && !isPublicPage(path));
        }

        Auth.current_user = null;
        if (shouldLoadCurrentUser()) {
            loadCurrentUser();
        }

        // The nav lives for the whole page, so a page opened on a public path
        // (an emailed /confirm_email link, with the user still signed in) would
        // keep the logged-in header with an empty name for the rest of the
        // visit. Load the user once the app reaches a page that shows it.
        // The path comes from the destination state: the stateEvents polyfill
        // broadcasts this before ui-router updates the URL (both are priority
        // 9999 onSuccess hooks), so $location still holds the page being left.
        $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
            var path = ($state.href(toState, toParams) || '').replace(/^#!?/, '');
            if (shouldLoadCurrentUser(path)) {
                loadCurrentUser();
            }
        });

        $scope.$on(HTTP_ERROR_EVENTS.requestTimeout, function(event, args){
            Notification.error("error.http.requestTimeout");
        });

        $scope.$on(HTTP_ERROR_EVENTS.serverError, function(event, args){
            Notification.error("error.http.serverError");
        });

        var showErrorModal = function(message) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/error_modal.html',
                controller: 'ErrorModalController',
                resolve: {
                    message: function(){
                        return message;
                    }
                }
            });
        };

        $scope.first_name = function() {
            var current_user = Auth.current_user;
            return (current_user || {}).first_name;
        };

        $scope.last_name = function() {
            var current_user = Auth.current_user;
            return (current_user || {}).last_name;
        };

        $scope.logged = function () {
            return Auth.get() != undefined;
        };

        // Impersonation state
        $scope.impersonation = {
            active: false,
            userName: '',
            practiceName: ''
        };
        
        // Check impersonation status on load
        var checkImpersonationStatus = function() {
            var info = ImpersonationState.getImpersonationInfo();
            if (info) {
                $scope.impersonation.active = true;
                $scope.impersonation.userName = info.user_name;
                $scope.impersonation.practiceName = info.practice_name;
            } else {
                $scope.impersonation.active = false;
            }
        };
        
        checkImpersonationStatus();
        
        // Listen for impersonation changes
        $scope.$on('impersonation:changed', function() {
            checkImpersonationStatus();
        });
        
        $scope.$watch(function() {
            return !!Auth.get();
        }, function(newVal, oldVal) {
            if (!newVal && oldVal) {
                // Auth was removed, clear impersonation state
                $scope.impersonation.active = false;
                $scope.impersonation.userName = '';
                $scope.impersonation.practiceName = '';
            }
        });
        
        // DCL-462: every identity switch below is a $state reload, not a page
        // reload, so the suppression warning's once-per-session flag and its
        // dontHideOnRequest toast both outlive the user who triggered them.
        // Leaving them in place would show one user's email address to the next
        // person at the same workstation and skip that person's own check.
        var clearEmailSuppressionWarning = function() {
            EmailSuppressionWarning.reset();
            // DCL-507: the trial-expiry toast carries the same once-per-session
            // flag and dontHideOnRequest lifetime, so it leaks across identities
            // the same way and is cleared at the same points.
            TrialExpiryWarning.reset();
            Notification.dismiss();
        };

        // An expired session is the third way to switch identity, alongside the
        // two logout paths below, and it is the one the user does not initiate.
        // AccountSetupActions carries the same once-per-session flag and is reset
        // for the same reason.
        $scope.$on(AUTH_EVENTS.notAuthenticated, function() {
            AccountSetupActions.reset();
            clearEmailSuppressionWarning();
        });

        // Stop impersonation
        $scope.stopImpersonating = function() {
            Impersonation.stop({}, function(response) {
                clearEmailSuppressionWarning();
                AccountSetupActions.reset();
                // Update auth context with restored super user
                Auth.set({
                    email: response.email,
                    roles: response.roles,
                    id: response.id,
                    practice_id: response.practice_id
                });
                // DCL-286: the impersonated practice's branding is still loaded
                // and still in the cookie, and the reload below is a state
                // reload rather than a page reload. Put the super user's own
                // branding back as their details arrive.
                Auth.current_user = User.get({id: response.id}, function(restoredUser) {
                    CustomBranding.applyForUser(restoredUser);
                });
                ImpersonationState.notifyChange();
                $state.go('console.practice', {}, {reload: true});
            }, function(error) {
                Notification.error('Failed to stop impersonation');
            });
        };

        // Open Patient Portal via SSO
        // The anchor's href points to PATIENT_PORTAL_HOST so hover/screen-readers see the real
        // destination; we preventDefault here to swap in the SSO URL returned by the backend.
        $scope.openPatientPortal = function($event) {
            if ($event) { $event.preventDefault(); }
            PatientPortal.ssoToken({}, function(response) {
                $window.open(response.portal_url, '_blank');
            }, function(error) {
                Logger.log('Patient Portal SSO error', error);
                Notification.error('Unable to open Patient Portal. Please try again.');
            });
        };

        $scope.logout = function(){
            if (UnsavedChanges.canLeaveSafely()) {
                Login.logout(function (success) {
                    Auth.remove();
                    Auth.current_user = null;
                    AccountSetupActions.reset();
                    clearEmailSuppressionWarning();
                    // Logging out is an explicit intent to leave: drop any saved
                    // post-login destination.
                    redirect.path = '/history';
                    // Clear impersonation state on logout
                    $scope.impersonation.active = false;
                    $scope.impersonation.userName = '';
                    $scope.impersonation.practiceName = '';
                    $state.go('signIn', {}, {reload: true});
                },
                function (failure) {
                    Logger.error('Logout failed', failure);
                    Auth.remove();
                    Auth.current_user = null;
                    AccountSetupActions.reset();
                    clearEmailSuppressionWarning();
                    // An expired session 401s this call and the authInterceptor
                    // captures the current URL into redirect first; the explicit
                    // logout intent must win over that capture.
                    redirect.path = '/history';
                    // Clear impersonation state on logout failure
                    $scope.impersonation.active = false;
                    $scope.impersonation.userName = '';
                    $scope.impersonation.practiceName = '';
                    $state.go('signIn', {}, {reload: true});
                });
            }
        }

    }]);
